import useStateWithTransformer from "@app/util/hook/useStateWithTransformer";

const transformer = (value: string) => value.toLowerCase();

const useLowerCaseState = (initialState: (() => string) | string) =>
  useStateWithTransformer<string>(initialState, transformer);

export default useLowerCaseState;
